import { Component, EventEmitter, Input, OnInit, Output, Type, ViewChild } from '@angular/core';

import { ComponentRendererComponent } from '@app/shared/ui/simple-components/component-renderer/component-renderer.component';

@Component({
  standalone: false,
  selector: 'ti-typified-modal',
  templateUrl: './typified-modal.component.html',
})
export class TypifiedModalComponent<T> implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() component: Type<T>;
  @Input() updater: (instance: T, data: any) => void;
  @Input() title: string;

  readonly miscStrings = tiStrings.app.misc;

  @ViewChild(ComponentRendererComponent) renderer: ComponentRendererComponent<any, any>;

  constructor() {}

  ngOnInit() {}

  onClose() {
    this.close.emit();
  }
}
